import * as loadingState from '../constants/loadingState';

export const FETCH_PLAN_DATA = 'FETCH_PLAN_DATA';
export const FETCH_PLAN_DATA_SUCCESS = 'FETCH_PLAN_DATA_SUCCESS';
export const FETCH_PLAN_DATA_FAILURE = 'FETCH_PLAN_DATA_FAILURE';

export const RESET_PLAN_DATA = 'RESET_PLAN_DATA';
export const SET_SELECTED_PLAN = 'SET_SELECTED_PLAN';
export const SET_HAS_SUBSCRIPTION = 'SET_HAS_SUBSCRIPTION';

export const fetchPlanData = ({ type, id, bundleContents }) => ({
  type: FETCH_PLAN_DATA,
  payload: {
    id,
    type,
    bundleContents,
  },
});

export const fetchPlanDataSuccess = ({
  collectionList,
  infos,
  infosHeader,
  contentList,
  bundleContents,
}) => ({
  type: FETCH_PLAN_DATA_SUCCESS,
  payload: {
    collectionList,
    infos,
    infosHeader,
    contentList,
    bundleContents,
  },
});

export const fetchPlanDataFailure = errorCode => ({
  type: FETCH_PLAN_DATA_FAILURE,
  payload: {
    errorCode,
  },
});

export const setSelectedPlan = selectedPlan => ({
  type: SET_SELECTED_PLAN,
  payload: { selectedPlan },
});

export const setHasSubscription = hasSubscription => ({
  type: SET_HAS_SUBSCRIPTION,
  payload: { hasSubscription },
});

export const resetPlanData = () => ({ type: RESET_PLAN_DATA });
const INIT_STATE = {
  status: loadingState.EMPTY,
  hasSubscription: false,
  collectionList: [],
  collectionListLoadingState: loadingState.EMPTY,
  contentList: [],
  selectedPlan: {},
  addonInfo: {},
  errorCode: '',
  bundleContents: [],
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PLAN_DATA:
      return {
        ...state,
        collectionListLoadingState: loadingState.LOADING,
      };
    case FETCH_PLAN_DATA_SUCCESS: {
      const {
        collectionList,
        infos,
        infosHeader,
        contentList,
        bundleContents,
      } = action.payload;

      return {
        ...state,
        bundleContents,
        collectionListLoadingState: loadingState.READY,
        collectionList,
        contentList,
        addonInfo: {
          infos,
          infosHeader,
        },
      };
    }
    case FETCH_PLAN_DATA_FAILURE:
      return {
        ...state,
        collectionListLoadingState: loadingState.ERROR,
        collectionList: [],
        errorCode: action.payload.errorCode,
      };
    case SET_SELECTED_PLAN:
      return {
        ...state,
        ...action.payload,
      };
    case SET_HAS_SUBSCRIPTION:
      return {
        ...state,
        hasSubscription: action.payload.hasSubscription,
      };
    case RESET_PLAN_DATA:
      return {
        ...state,
        bundleContents: INIT_STATE.bundleContents,
        collectionListLoadingState: INIT_STATE.loadingState,
        collectionList: INIT_STATE.collectionList,
        contentList: INIT_STATE.contentList,
        errorCode: INIT_STATE.errorCode,
      };

    default:
      return state;
  }
};

export default reducer;

export const getCollectionList = state => state.plans.collectionList;
export const getCollectionListLoadingState = state =>
  state.plans.collectionListLoadingState;
export const getCollectionContentList = state => state.plans.contentList;
export const getBundleContents = state => state.plans.bundleContents;
export const getSelectedPlan = state => state.plans.selectedPlan;
export const getHasSubscription = state => state.plans.hasSubscription;
export const getAddonInfo = state => state.plans.addonInfo;
export const getErrorCode = state => state.plans.errorCode;



// WEBPACK FOOTER //
// ./app/redux/plans.js